import { render, staticRenderFns } from "./PlaceHierarchyItem.vue?vue&type=template&id=05dabda6&"
import script from "./PlaceHierarchyItem.vue?vue&type=script&lang=ts&"
export * from "./PlaceHierarchyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports